import { httpsCallable, type Functions } from "firebase/functions";
import { SEND_PERFUME_BY_EMAIL_FUNCTION, type SendPerfumeByEmailRequest } from "@/models";

// the email is built and sent by a Cloud Function (functions/src/index.ts)
export class PerfumeEmailRepository {
  functions: Functions;

  constructor(functions: Functions) {
    this.functions = functions;
  }

  // throws a FunctionsError: "functions/invalid-argument", "functions/resource-exhausted"…
  async sendPerfumeByEmail(request: SendPerfumeByEmailRequest): Promise<void> {
    await httpsCallable<SendPerfumeByEmailRequest>(
      this.functions,
      SEND_PERFUME_BY_EMAIL_FUNCTION,
    )(request);
  }
}
